export const CV_PDF_MARCO_MAIGUA_GOOGLE_CLOUD_URL = "https://storage.cloud.google.com/cms-personal.appspot.com/documents/Marco-Maigua-v2-english-2026.pdf"
export const LINKEDIN_PROFILE_URL="https://www.linkedin.com/in/marco-maigua-66822584/"
export const GITHUB_PROFILE_URL="https://github.com/nemesis1346"
export const MEDIUM_PROFILE_URL="https://medium.com/@nemesis1346"